import {api} from 'api/setup';
import {IMarketPromotionRequest, IMarketPromotionResponse, IMarketsRequest, IMarketsResponse} from 'types';

const BASE_PATH = 'market';

export const getMarkets = (params?: IMarketsRequest): Promise<IMarketsResponse> => {
  return api.get(`/${BASE_PATH}s`, {params});
};

export const getMarketPromotion = (params?: IMarketPromotionRequest): Promise<IMarketPromotionResponse> => {
  return api.get(`/${BASE_PATH}-promotions`, {params});
};
